<template>
  <ion-app>
    <router-view id="routerView" :key="$route.fullPath" />
    <ion-alert-controller></ion-alert-controller>
    <main-popup-modal />
    <div class="loading-spinner" style="display: none"></div>
    <audio-player ref="player" />
    <hamburger />
    <footer-toolbar v-show="isMainPage" />
  </ion-app>
</template>

<script>
import * as ajax from './utils/ajax'
import * as alert from './utils/alert'
import * as biz from "./utils/biz"
import * as utils from "./utils/utils"
import Hamburger from "./components/Hamburger";
import AudioPlayer from "./components/AudioPlayer";
import FooterToolbar from "./components/footer/FooterToolbar";
import MainPopupModal from "./views/main/MainPopupModal";
import './css/checkbox.css';

export default {
  name: "App",
  components: {AudioPlayer, Hamburger, FooterToolbar, MainPopupModal},
  data() {
    return {
      app: {
        version: "1.0"
      },
      regist_app_version: "",
      appversion: "",
      isShowGuide:false
    }
  },
  mounted() {
    var splits = window.navigator.userAgent.split("|");
    if (splits.length > 2) {
      var appversion = splits[splits.length - 1]
      this.appversion = appversion.replace(".", '').replace(".", '');
    }
    else
      this.appversion = "0";

    // 공통쿠키 검색
    if (this.$cookie.get("schoolDiv") === null) {
      this.$cookie.set("schoolDiv", "", 365);
    }
    if (this.$cookie.get("schoolGrade") === null) {
      this.$cookie.set("schoolGrade", "", 365);
    }
    if (this.$cookie.get("lteStreaming") === null) {
      this.$cookie.set("lteStreaming", false, 365);
    }

    var accessToken = this.$cookie.get("accessToken");
    if (accessToken == null)
      accessToken = "";
    var schoolDiv = this.$cookie.get("schoolDiv");
    if (schoolDiv == null)
      schoolDiv = "";
    var schoolGrade = this.$cookie.get("schoolGrade");
    if (schoolGrade == null)
      schoolGrade = "";
    const params = {
      accessToken: accessToken,
      schoolDiv: schoolDiv,
      schoolGrade: schoolGrade
    };
    // console.log('setAccessToken :' + params);
    switch(utils.deviceInfo()) {
      case "Android":
        // this.getAppVersion("01");
        window.listenApp.setAccessToken(JSON.stringify(params));
        window.listenApp.hideSplash();
        window.listenApp.deviceInfo();
        break;
      case "iOS":
        // this.getAppVersion("02");
        window.webkit.messageHandlers.setAccessToken.postMessage(params);
        window.webkit.messageHandlers.hideSplash.postMessage();
        break;
    }

    window.deviceInfo = this.androidDeviceInfo;

    // Android back button 기능정의
    if (utils.deviceInfo() === "Android") {
      window.backClick = this.backButton;
    }

  },
  methods: {
    // getAppVersion(appCode) {
    //   const param = {
    //     "group_code": "APP_VERSION_DIV",
    //     "code": appCode
    //   };
    //
    //
    //   ajax.Post(this, "/api/common/code/search", param, function(ref, data) {
    //     ref.regist_app_version = data[0].value.replace(".", '').replace(".", '');
    //
    //     console.info("appversion = " + ref.appversion);
    //     console.info("regist_app_version = " + ref.regist_app_version);
    //     if (Number(ref.appversion) < Number(ref.regist_app_version) || ref.appversion == "0") {
    //       ref.updateAppGuide(appCode)
    //     }
    //   });
    // },
    androidDeviceInfo(deviceToken, deviceId, appVersion) {
      this.app.version = appVersion;

      if (this.app.version < 1.2) {
        const storeLink = "https://play.google.com/store/apps/details?id=com.textbooklistening.android";
        alert.alertLink("신규 업데이트가 있습니다. \n새로운 버전으로 업데이트 해 주세요.", "확인", this, storeLink);
      }
    },
    backButton() {
      if (this.$refs.player.playerInfo.mode === "basic") {
        this.$refs.player.playerInfo.mode = "mini";
      } else {
        this.$router.go(-1);
      }
    }
    // ,
    // updateAppGuide(deviceType) {
    //
    //   // // android 가 준비되면 다시 오픈
    //   // if (deviceType === "01")
    //   //   return;
    //
    //   if (this.isShowGuide)
    //     return;
    //   this.isShowGuide = true;
    //
    //   var message = "<b>듣는동화</b>의 새로운 버전이 등록되었습니다.\n";
    //   if (deviceType === "01")
    //     message += "PlayStore를 통해 <b>듣는동화</b>의 새로운 버전으로 다시 설치해 주세요. \n감사합니다.";
    //   else
    //     message += "AppStore를 통해 <b>듣는동화</b>의 새로운 버전으로 다시 설치해 주세요. \n감사합니다.";
    //
    //
    //   document.querySelector('ion-alert-controller').create({
    //     message: message,
    //     buttons: [
    //       {
    //         text: '확인',
    //         role: 'cancel',
    //         cssClass: 'secondary',
    //         handler: () => {
    //           // console.log('Confirm Cancel');
    //           this.isShowGuide = false;
    //         },
    //       },
    //     ],
    //     mode: "ios"
    //   }).then(alert => {
    //     alert.present();
    //   });
    // }

    // callIsconnectWIFI() {
    //     window.listenApp.isConnectWIFI();
    // },
    // callAudioList() {
    //     window.listenApp.getAudioList();
    // },
    // receiveIsconnectWIFI(value) {
    //     console.log(value);
    // },
    // receiveOfflineAudioFileList(fileList) {
    //     for (const item of fileList) {
    //         console.log(item);
    //     }
    // }
  },
  computed: {
    isMainPage() {
      return this.$route.path === '/';
    }
  }
}
</script>

<style lang="scss">
:root {
  --ion-font-family: "Noto Sans KR", sans-serif;

  // 기존에 등록된 컬러는 컬러만 변경
  --ion-color-primary: #ff6b00;
  --ion-color-primary-rgb: 255,107,0;
  --ion-color-primary-contrast: #ffffff;
  --ion-color-primary-contrast-rgb: 0,0,0;
  --ion-color-primary-shade: #e05e00;
  --ion-color-primary-tint: #ff7a1a;
}
</style>
